import { AnimatePresence, motion } from "framer-motion";

const COLORS = {
  good: "#38BDF8",
  love: "#EC4899",
  bad: "#EF4444",
  zoom: "#A855F7",
  gold: "#F59E0B",
};

export default function ReactionOverlay({ reactions }) {
  return (
    <div className="pointer-events-none absolute inset-0 z-30 overflow-hidden" data-testid="reaction-overlay">
      <AnimatePresence>
        {reactions.map((r) => (
          <motion.div
            key={r.id}
            initial={{ opacity: 0, y: 10, scale: 0.6 }}
            animate={{ opacity: 1, y: -110, scale: 1.15 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.1, ease: "easeOut" }}
            className="absolute font-display font-extrabold text-2xl sm:text-3xl drop-shadow-lg"
            style={{ left: `${r.x}%`, top: "58%", color: COLORS[r.type] || "#fff" }}
          >
            {r.text}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
